import React from "react";
import { useLanguage } from "../context/LanguageContext";

export const LittleNote = () => {
    const { t } = useLanguage();
    return (
        <section
            id="archive"
            data-testid="little-note-section"
            className="relative"
        >
            <div className="max-w-[1320px] mx-auto px-6 lg:px-12 py-12 lg:py-16">
                <div
                    className="relative rounded-[28px] overflow-hidden grain-overlay px-8 sm:px-14 py-14 lg:py-20"
                    style={{
                        background:
                            "linear-gradient(135deg, var(--peach-soft) 0%, var(--peach) 100%)",
                    }}
                >
                    <div className="flex items-center flex-wrap gap-4">
                        <div
                            className="inline-flex items-center gap-2 font-mono-archive text-[10px] px-3 py-1.5 rounded-full"
                            style={{
                                background: "rgba(26,26,26,0.08)",
                                color: "var(--ink-soft)",
                            }}
                        >
                            <span
                                className="w-1.5 h-1.5 rounded-full pulse-dot"
                                style={{ background: "var(--ink)" }}
                            />
                            {t("note.available")}
                        </div>
                    </div>

                    <div className="mt-10 grid lg:grid-cols-12 gap-10 items-end">
                        <div className="lg:col-span-8">
                            <div
                                className="font-serif-display italic text-[22px]"
                                style={{ color: "var(--ink-soft)" }}
                            >
                                {t("note.small")}
                            </div>
                            <h2
                                className="font-serif-display text-[44px] sm:text-[60px] lg:text-[76px] leading-[1.02] mt-3"
                                style={{ color: "var(--ink)" }}
                            >
                                {t("note.title.a")}
                                <br />
                                <span
                                    className="italic"
                                    style={{ color: "var(--terracotta-deep)" }}
                                >
                                    {t("note.title.b")}
                                </span>
                            </h2>
                        </div>

                        <div className="lg:col-span-4 flex lg:justify-end">
                            <a
                                href="#contact"
                                data-testid="open-the-book-btn"
                                className="pill pill-primary"
                            >
                                {t("note.cta")}
                                <span aria-hidden>↗</span>
                            </a>
                        </div>
                    </div>

                    <svg
                        className="absolute -bottom-6 -right-6 opacity-50"
                        width="220"
                        height="220"
                        viewBox="0 0 220 220"
                        fill="none"
                    >
                        <path
                            d="M20 180 Q 80 60 200 30"
                            stroke="rgba(26,26,26,0.35)"
                            strokeWidth="1"
                            fill="none"
                        />
                        <circle
                            cx="200"
                            cy="30"
                            r="3.5"
                            fill="rgba(26,26,26,0.5)"
                        />
                        <path
                            d="M40 200 L 60 200 M 50 190 L 50 210"
                            stroke="rgba(26,26,26,0.35)"
                            strokeWidth="1"
                        />
                    </svg>
                </div>
            </div>
        </section>
    );
};
